import * as React from 'react';
import { IconProps } from '../types';

const IcCashierZoomOut = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M11.5 3.75a7.25 7.25 0 1 0 5.044 12.457.753.753 0 0 1 .163-.163A7.25 7.25 0 0 0 11.5 3.75Zm6.695 12.884a8.75 8.75 0 1 0-1.06 1.06l3.835 3.836a.75.75 0 1 0 1.06-1.06l-3.835-3.836ZM7.75 11a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcCashierZoomOut;
